/**
 * Обёртка над localStorage. В WebView Telegram (iOS private mode, отключённые
 * сторонние хранилища) обращение к localStorage бросает исключение — приложение
 * от этого падать не должно, просто теряется сохранённый прогресс.
 */

export function readStorage<T>(key: string, revive: (raw: unknown) => T | null): T | null {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return null;
    return revive(JSON.parse(raw));
  } catch {
    return null;
  }
}

export function writeStorage(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Переполнение квоты или запрет на запись — не критично, продолжаем без персиста.
  }
}

export function removeStorage(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // См. writeStorage.
  }
}
